import React from "react";


function Contact() {
  return (
    <div>
      <div className="row banner" style={{ display:'flex',alignItems:'center',justifyContent:'center',background:'orange', backgroundSize: 'cover', backgroundPosition: 'center',height:'400px' }}>
      <img src="./images/maruthi.png" alt="image" style={{width:'20%'}} />
      </div>
      <div className="container" style={{ clear:'both',marginTop: '100px', marginBottom: '100px' }}>

        <div className="row">
          <div className="col-md-5" style={{ background: '#ffffffff', padding: '50px' }}>
            <div className="row" style={{ borderBottom: '0px solid orange', paddingBottom: '15px', paddingTop: '15px' }}>
              <h3 className="cheading" >Address</h3>
              {/* first */}
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-map-marker contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  <p className="addr"> Sreekrishna Maruthi temple
                    Maruthipuram,  kara
                    edavilangu village<br />
                    kodungallur
                    Thrissur,
                    Kerala <br />
                    pin 680671
                  </p>
                </div>


              </div>
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-phone-square contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  <p className="addr">8129981222</p>
                </div>
              </div>
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-envelope contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  <p className="addr">sreekrishnamaruthitemple@gmail.com
                  </p>
                </div>
              </div>

            </div>
          </div>

          <div className="col-md-7" style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}>

            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1007714.453730831!2d75.90476424015841!3d9.387603197296233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b081eb5e54995d9%3A0x24dc1006f05ec34d!2sSree%20Krishna%20Maruthi%20Temple%2C%20Kara!5e0!3m2!1sen!2sin!4v1765878417319!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>



          </div>
        </div>


      </div>
    </div>
  );
}

export default Contact;